import styled, { ITheme } from '../../../theme'

const HelpButton = styled.a`
  cursor: pointer;
  border: 0px;
  margin: 0px;
  font-size: 1em;
  font-weight: 500;
  display: flex;
  justify-content: center;
  padding: 0px 30px;
  align-items: center;
  color: ${(props: ITheme) => props.theme.colors.palette.darkGreyTwo};
`

export default HelpButton
